import React from 'react';
import { UploadChangeParam } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';

import { BaseUploadFile, FileValue } from 'components/wrappers/BaseFileUpload';
import adminApiClient from 'api/adminApiClient';
import { getFileUploadMessages } from 'utils/fileUtils';
import FormikFileUpload from 'components/formik/FormikFileUpload';
import backofficeApiClient, {
  FileParameter,
  WorkerTypeEnum,
} from 'api/backofficeApiClient';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';

const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'RTF'];
const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

type Props = {
  fieldName: string;
  isAdmin: boolean;
  workerFiles?: BaseUploadFile[];
  disabled?: boolean;
  workerType?: WorkerTypeEnum;
  onChange?: (files: BaseUploadFile[], index?: number) => void;
  isSimpleUpload?: boolean;
  index?: number;

};

export default React.memo((props: Props) => {
  const {
    fieldName,
    workerFiles = [],
    disabled,
    isAdmin,
    workerType,
    onChange,
    isSimpleUpload,
    index
  } = props;

  const uploadWorkerFileLinkFunction = isAdmin
    ? adminApiClient.getWorkerFileUploadLink.bind(adminApiClient)
    : backofficeApiClient.getWorkerFileUploadLink.bind(backofficeApiClient);

  const uploadContractorCompanyFileLinkFunction = isAdmin
    ? adminApiClient.getContractorCompanyFileUploadLink.bind(adminApiClient)
    : backofficeApiClient.getContractorCompanyFileUploadLink.bind(
        backofficeApiClient,
      );

  const uploadFileLinkFunction =
    workerType === WorkerTypeEnum.SC
      ? uploadContractorCompanyFileLinkFunction
      : uploadWorkerFileLinkFunction;

  const handleFileChange = (
    fileValues: FileValue[] | string[] | FileParameter[],
    value: UploadFile[],
    fileInfo: UploadChangeParam,
  ) => {
    if (!onChange) return;

    const { fileList } = fileInfo;

    if (!fileList.length) {
      onChange([], index);
      return;
    }

    const uploadedFiles = fileList.filter((file) => file.status === 'done');

    if (!uploadedFiles.length) return;

    onChange(uploadedFiles, index);
  };

  return (
    <FormikFileUpload
      name={fieldName}
      fileList={workerFiles}
      isDraggable
      disabled={disabled}
      maxFileCount={1}
      acceptedFileSize={10}
      acceptedFileFormat={[
        '.doc',
        '.docx',
        '.pdf',
        '.rtf',
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]}
      getUploadList={UploadList}
      messages={fileUploadMessages}
      onChange={handleFileChange}
      uploadLinkFunction={uploadFileLinkFunction}
    >
      {() =>
        isSimpleUpload ? (
          <i className="icon icon-upload" />
        ) : (
          <BaseDraggerContent fileTypes={FILE_TYPES} />
        )
      }
    </FormikFileUpload>
  );
});
